import { styled, Tab, Tabs } from '@mui/material';

/**
 * Tab count badges sit in the flow after the label. Anchored, MUI offsets them by half
 * their own width, so no fixed offset clears the label once the count grows.
 */
export const CardTab = styled(Tab)({
  fontSize: '16px',
  textTransform: 'none',
  overflow: 'visible',
  boxShadow: 'none !important',
  '& .MuiBadge-root': {
    alignItems: 'center',
    gap: '6px',
  },
  '& .MuiBadge-badge': {
    position: 'static',
    transform: 'none',
    margin: 0,
  },
  // MUI hides a zero count by scaling it to 0, which `transform: none` would undo.
  '& .MuiBadge-invisible': {
    display: 'none',
  },
});

// A card's tab strip is chrome: the header surface, so it separates from the body.
export const CardTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: (theme.vars || theme).palette.cardHeaderBackground,
  borderBottom: `1px solid ${(theme.vars || theme).palette.borderColor}`,
  boxShadow: (theme.vars || theme).palette.elevation.rim,
}));
